import { createAsyncThunk } from '@reduxjs/toolkit';
import { securedAxiosInstance } from '../../../api/axios';

export const getOrganisations = createAsyncThunk(
  'organisations/getOrganisations',
  async (arg, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.get(`/organisations`);
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getMyOrganisation = createAsyncThunk(
  'organisations/getMyOrganisation',
  async (arg, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.get(`/me`);
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const searchOrganisations = createAsyncThunk(
  'organisations/searchOrganisations',
  async ({ val }, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.post(
        `/organisations/search`,
        {
          organisation: {
            search: val,
          },
        }
      );
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const deleteOrg = createAsyncThunk(
  'organisations/deleteOrg',
  async ({ orgId }, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.delete(
        `/organisations/${orgId}`
      );
      return { ...response, orgId };
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const saveOrganisation = createAsyncThunk(
  'organisations/saveOrganisation',
  async ({ data, isUpdate, myOrg = false }, { getState, rejectWithValue }) => {
    try {
      let response;
      if (isUpdate.state) {
        response = await securedAxiosInstance.patch(
          `/organisations/${isUpdate.organisation.id}`,
          {
            organisation: data,
          }
        );
      } else {
        response = await securedAxiosInstance.post(`/organisations`, {
          organisation: data,
        });
      }

      return { ...response, isUpdate, orgData: data, myOrg };
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const overrideOrganisationBoxes = createAsyncThunk(
  'organisations/overrideOrganisationBoxes',
  async ({ data }, { getState, rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.post(
        `/organisations/override`,
        data
      );

      return { response };
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const adminOverrideOrganisationBoxes = createAsyncThunk(
  'organisations/adminOverrideOrganisationBoxes',
  async ({ data, id }, { getState, rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.post(
        `/organisations/${id}/override`,
        data
      );

      return { response };
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getOrgUsers = createAsyncThunk(
  'organisations/getOrgUsers',
  async ({ orgId }, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.get(
        `/organisations/${orgId}/users`
      );
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const saveOrgUser = createAsyncThunk(
  'organisations/saveOrgUser',
  async ({ data, isUpdate }, { rejectWithValue }) => {
    try {
      let response;
      if (isUpdate.state) {
        response = await securedAxiosInstance.patch(
          `/users/${isUpdate.user.id}`,
          {
            user: data,
          }
        );
      } else {
        response = await securedAxiosInstance.post(`/users`, {
          user: data,
        });
      }

      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const deleteOrgUsers = createAsyncThunk(
  'organisations/deleteOrgUsers',
  async ({ selectedUsers }, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.post(`/users/disable_users`, {
        users: { user_id: selectedUsers },
      });
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
